import { render, staticRenderFns } from "./buy-invoices-tab.vue?vue&type=template&id=4ca14c94&scoped=true"
import script from "./buy-invoices-tab.vue?vue&type=script&lang=js"
export * from "./buy-invoices-tab.vue?vue&type=script&lang=js"
import style0 from "./buy-invoices-tab.vue?vue&type=style&index=0&id=4ca14c94&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca14c94",
  null
  
)

export default component.exports